module.exports = "/cyber/_next/static/images/PubgTooltip-60ae9563cff9bb8713321d5287792a7e.jpg";